export const AcceptedStatusCodes = [200, 204, 401, 400, 403, 404];

export const NotFoundCodes = [404];

export const AccessForbiddenCodes = [403];
